import React, { useState, useEffect } from 'react';
import './Navbar.css';
import denviaLogo from '../../assets/ivory/DenviaLogoMain.png';
import {
  CONTACTUS_SECTION_ID,
  HOME_SECTION_ID,
  SERVICE_SECTION_ID,
} from '../../utils/Constant';
import { handleScroll } from '../../utils/Utils';
import { useNavigate, useLocation } from 'react-router-dom';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeSection, setActiveSection] = useState("");
  const [showGalleryDropdown, setShowGalleryDropdown] = useState(false);

  const navbarItems = [
    { name: 'Home', type: 'section', id: HOME_SECTION_ID },
    { name: 'About Us', type: 'page', path: '/about' },
    { name: 'Know Your Doctor', type: 'page', path: '/knowyourdoctor' },
    { name: 'Services', type: 'page', path: '/services' },
    { name: 'Gallery', type: 'dropdown', hasDropdown: true },
    { name: 'Contact Us', type: 'section', id: CONTACTUS_SECTION_ID }
  ];

  const galleryDropdownItems = [
    { name: 'Clinic Images', path: '/gallery/clinic' },
    { name: 'Our Work', path: '/gallery/our-work' }
  ];

  const handleNavigation = (id, isSection = false) => {
    if (isSection) {
      if (location.pathname === "/") {
        handleScroll(id);
      } else {
        navigate("/");
        setTimeout(() => handleScroll(id), 400);
      }
    } else {
      navigate(id);
    }
  };

  const handleGalleryNavigation = (path) => {
    setShowGalleryDropdown(false);
    navigate(path);
  };

  // Highlight active section on scroll (only on homepage)
  useEffect(() => {
    if (location.pathname !== "/") return;

    const handleScrollEffect = () => {
      navbarItems.forEach(({ id, type }) => {
        if (type === "section") {
          const section = document.getElementById(id);
          if (section && section.getBoundingClientRect().top <= 100) {
            setActiveSection(id);
          }
        }
      });
    };

    window.addEventListener("scroll", handleScrollEffect);
    return () => window.removeEventListener("scroll", handleScrollEffect);
  }, [location.pathname]);

  // Remove scroll background logic completely (client doesn't want it)

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.gallery-dropdown-container')) {
        setShowGalleryDropdown(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  return (
    <div className="main-nav">
      <div className="container">
        <nav className="navbar navbar-expand-lg">
          <div className="container-fluid">

            {/* Logo */}
            <div
              className="navbar-brand"
              onClick={() => handleNavigation(HOME_SECTION_ID, true)}
              style={{ cursor: 'pointer' }}
            >
              <img src={denviaLogo} className='company-logo' alt="Logo" />
            </div>

            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="navbar-nav m-auto mb-2 mb-lg-0">
                {navbarItems.map(({ name, id, type, hasDropdown, path }) => {
                  let isActive = false;

                  if (type === "section") {
                    isActive = location.pathname === "/" && activeSection === id;
                  } else if (type === "dropdown") {
                    isActive = location.pathname.startsWith('/gallery');
                  } else if (type === "page") {
                    isActive = location.pathname === path;
                  }

                  if (hasDropdown) {
                    return (
                      <li key={name} className="nav-item gallery-dropdown-container">
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            setShowGalleryDropdown(!showGalleryDropdown);
                          }}
                          className={`nav-link dropdown-toggle ${isActive ? "active" : ""}`}
                        >
                          {name}
                        </span>

                        {/* Dropdown */}
                        <div className={`gallery-dropdown-menu ${showGalleryDropdown ? 'show' : ''}`}>
                          {galleryDropdownItems.map((item) => (
                            <span
                              key={item.path}
                              className={`gallery-dropdown-item ${location.pathname === item.path ? 'active' : ''}`}
                              onClick={() => handleGalleryNavigation(item.path)}
                            >
                              {item.name}
                            </span>
                          ))}
                        </div>
                      </li>
                    );
                  }

                  return (
                    <li key={id || name} className="nav-item">
                      <span
                        onClick={() => {
                          if (type === "section") handleNavigation(id, true);
                          else if (type === "page") navigate(path);
                        }}
                        className={`nav-link ${isActive ? "active" : ""}`}
                      >
                        {name}
                      </span>
                    </li>
                  );
                })}
              </ul>
            </div>

          </div>
        </nav>
      </div>
    </div>
  );
};

export default Navbar;
